import { UserService } from '@profile/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UpdateUserCommandPayload } from './update-user.command-payload';
import { UpdateMyUserBody } from '@core-http';

export class UpdateUserCommandHandler {
  private readonly userService: UserService = inject(UserService);

  update(payload: UpdateUserCommandPayload): Observable<void> {
    const requestBody: UpdateMyUserBody = {
      ...payload,
      phone: payload.phone ? `+48${payload.phone}` : null
    } as UpdateMyUserBody;

    return this.userService.updateUser(requestBody).pipe(map(() => void 0));
  }
}
